import { pickT } from "@repo/shared";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { T } from "./settings-expected-value-form.i18n";

type SettingsExpectedValueFormProps = {
  flowLanguage: string;
  showChart: boolean;
  onShowChartChange: (show: boolean) => void;
  showSummaryTable: boolean;
  onShowSummaryTableChange: (show: boolean) => void;
  showYearlyTable: boolean;
  onShowYearlyTableChange: (show: boolean) => void;
  compareWithBank: boolean;
  onCompareWithBankChange: (show: boolean) => void;
};

export function SettingsExpectedValueForm({
  flowLanguage,
  showChart,
  onShowChartChange,
  showSummaryTable,
  onShowSummaryTableChange,
  showYearlyTable,
  onShowYearlyTableChange,
  compareWithBank,
  onCompareWithBankChange,
}: SettingsExpectedValueFormProps) {
  const t = pickT(T, flowLanguage);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="expected-value-show-chart" className="text-base">
            {t.showLineChart}
          </Label>
          <p className="text-sm text-muted-foreground">{t.showLineChartDesc}</p>
        </div>
        <Switch
          id="expected-value-show-chart"
          checked={showChart}
          onCheckedChange={onShowChartChange}
        />
      </div>

      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="expected-value-show-summary-table" className="text-base">
            {t.showSummaryTable}
          </Label>
          <p className="text-sm text-muted-foreground">{t.showSummaryTableDesc}</p>
        </div>
        <Switch
          id="expected-value-show-summary-table"
          checked={showSummaryTable}
          onCheckedChange={onShowSummaryTableChange}
        />
      </div>

      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="expected-value-show-yearly-table" className="text-base">
            {t.showYearlyTable}
          </Label>
          <p className="text-sm text-muted-foreground">{t.showYearlyTableDesc}</p>
        </div>
        <Switch
          id="expected-value-show-yearly-table"
          checked={showYearlyTable}
          onCheckedChange={onShowYearlyTableChange}
        />
      </div>

      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="expected-value-compare-with-bank" className="text-base">
            {t.compareWithBank}
          </Label>
          <p className="text-sm text-muted-foreground">{t.compareWithBankDesc}</p>
        </div>
        <Switch
          id="expected-value-compare-with-bank"
          checked={compareWithBank}
          onCheckedChange={onCompareWithBankChange}
        />
      </div>

      {!showChart && !showSummaryTable && !showYearlyTable && (
        <div className="text-sm text-destructive bg-destructive/10 p-3 rounded-md">
          {t.atLeastOneDisplayOption}
        </div>
      )}
    </div>
  );
}
